import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { ColumnExportButton, Table } from 'barnyard/components';

const columns = [{
  Header: 'Date',
  id: 'date',
  accessor: row => moment(row.date).format('MMMM Do, YYYY')
}, {
  Header: 'Buyer',
  accessor: 'buyer_name',
}, {
  Header: 'Supplier',
  accessor: 'supplier_name',
}, {
  Header: 'Link',
  accessor: 'id',
  Cell: ({ value }) => <Link to={`/corporate/invoices/invoices/${value}`}>View Invoice</Link>,
  includeInExport: false
}];


const InvoiceNotGlCodedTable = ({ invoices, includeExport }) => (
  <Table
    actions={includeExport
      && <div className='u-paddingTop10'>
        <ColumnExportButton
          filename='Vetcove_Invoices_Not_GlCoded.csv'
          columns={columns}
          data={invoices}
        >
          Download
        </ColumnExportButton>
      </div>
    }
    size='small'
    columns={columns}
    data={invoices}
    pageSize={invoices.length || 10}
    showPagination={false}
  />
);

InvoiceNotGlCodedTable.propTypes = {
  invoices: PropTypes.array.isRequired,
  includeExport: PropTypes.bool
};

export default InvoiceNotGlCodedTable;
